var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12.223"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon/Dropdown Copy"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon/Dropdown Copy background",
    fill: "rgba(0,0,0,0)",
    d: "M0 12.223V0h16v12.223z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "ICon/Dropdown",
    d: "M5.951 0 5 .951l5.161 5.161L5 11.272l.951.951 5.16-5.161.951-.951-.951-.951Z",
    fill: "currentColor"
  }))));
};
export default SvgRightArrow;